/**
 * Configuration déclarative pour l'entité Form
 * Source unique de vérité pour tous les champs de Form
 */

import type { Form } from '../../types/form';
import { defineEntityConfig } from '../../lib/entity-config';

export const FORM_CONFIG = defineEntityConfig<Form>({
  entityName: 'formulaire',
  entityNamePlural: 'formulaires',

  fields: {
    name: {
      key: 'name',
      label: 'Nom',
      type: 'text',
      required: true,
      sortable: true,
      showInTable: true,
      showInFilters: true,
      exportable: true,
      importable: true,
      size: 200,
      importValidation: (value) => {
        if (typeof value !== 'string') return 'Le nom doit être une chaîne de caractères';
        if (value.length < 2) return 'Le nom doit contenir au moins 2 caractères';
        return true;
      },
    },

    product: {
      key: 'product',
      label: 'Produit',
      type: 'relation',
      sortable: false,
      showInTable: true,
      showInFilters: false, // Filtre personnalisé ajouté manuellement
      exportable: true,
      importable: false, // Relations gérées manuellement
      exportTransform: (product: any) => product?.name || '',
    },

    origin: {
      key: 'origin',
      label: 'Origine',
      type: 'relation',
      sortable: false,
      showInTable: true,
      showInFilters: false,
      exportable: true,
      importable: false, // Relations gérées manuellement
      exportTransform: (origin: any) => origin?.label || '',
    },

    is_active: {
      key: 'is_active',
      label: 'Statut',
      type: 'boolean',
      sortable: true,
      editable: true,
      showInTable: true,
      showInFilters: true,
      exportable: true,
      importable: true,
      exportTransform: (value: boolean) => (value ? 'Actif' : 'Inactif'),
      importTransform: (value: string) =>
        ['actif', 'active', 'oui', 'yes', 'true', '1'].includes(value.toLowerCase()),
    },

    created_at: {
      key: 'created_at',
      label: 'Date de création',
      type: 'date',
      sortable: true,
      showInTable: false, // Pas dans la table selon l'utilisateur
      showInFilters: true,
      exportable: true,
      importable: false,
      size: 150,
      exportTransform: (value: string) =>
        value ? new Date(value).toLocaleDateString('fr-FR') : '',
    },
  },
});
